import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";

export const Wrapper = styled.div`
  position: relative;
`;

export const Title = styled.div`
  ${({ theme, open }) => css`
    width: 4rem;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: white;
    font-weight: 500;
    font-family: Roboto;

    svg {
        transition: transform 0.3s ease;
        transform: ${open ? "rotate(45deg)" : "rotate(0deg)"};
    }

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        margin-left: 1rem;
      }
    }
  `}
`;

export const SubLinks = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.blue};
    border-radius:5px;

    width: 26rem;
    padding-bottom: 2rem;
    padding-top: 2rem;

    display: flex;
    flex-direction: column;
    position: absolute;
    top: 3rem;
    right: -3rem;
  `}
`;

export const SubLink = styled(NavLink)`
  ${({ theme }) => css`
    display: flex;
    padding:.5rem;
    align-items: center;
    width:100%;
    color: #FFF;
    &:first-child {
        margin-top: 0;
    }
    &:hover, &:focus {
          cursor: pointer;
          font-weight: bold;
          background-color: ${theme.colors.lineBlue};
        }
  `}
`;
